module.exports = __webpack_public_path__ + "img/logo-icon.f49d1f47.png";